import {CopyConfigurationState} from './states/copy-configuration.state';

export const copyConfigurationState = [
    CopyConfigurationState
];
